import { useState } from 'react';
import { COPY } from '../content';
import { verifyCreds } from '../api';
import { defaultBaseUrl, setCreds } from '../session';

export function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [baseUrl, setBaseUrl] = useState(defaultBaseUrl());
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [bad, setBad] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBad(false);
    setBusy(true);
    const url = baseUrl.replace(/\/+$/, '');
    const ok = await verifyCreds(url, token.trim());
    setBusy(false);
    if (!ok) {
      setBad(true);
      return;
    }
    setCreds({ baseUrl: url, token: token.trim() });
    onSignedIn();
  }

  return (
    <div className="login">
      <div className="card stack">
        <h1 className="screen-title">{COPY.login.title}</h1>
        <p className="muted small">{COPY.login.blurb}</p>
        <form onSubmit={submit} className="stack">
          <label className="small muted" htmlFor="api">
            {COPY.login.apiLabel}
          </label>
          <input id="api" value={baseUrl} onChange={(e) => setBaseUrl(e.target.value)} autoComplete="off" />
          <label className="small muted" htmlFor="tok">
            {COPY.login.tokenLabel}
          </label>
          <input
            id="tok"
            type="password"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            autoComplete="off"
          />
          {bad ? <div className="banner err">{COPY.login.bad}</div> : null}
          <button type="submit" disabled={busy || !token.trim()}>
            {busy ? 'Checking...' : COPY.login.button}
          </button>
        </form>
      </div>
    </div>
  );
}
